import '@inovua/reactdatagrid-community/index.css';
import React from 'react';
// import {useHistory} from 'react-router-dom';
import { inject } from 'mobx-react';

import { Table, Column, HeaderCell, Cell} from 'rsuite-table';
import 'rsuite-table/dist/css/rsuite-table.css';

const baseTableProps = {
    height: 720,
};

const baseStyles = {
    zIndex: 0,
}

export const ArtistGrid = ({dataSource, onRowClick}) => {
    return (
      <Table data={dataSource} {...baseTableProps} style={baseStyles} onRowClick={onRowClick}>
                 {/* <Column width={60} fixed>
                     <HeaderCell />
                     <Cell>{rowData => (
                         <input
                             type="checkbox"
                             checked={isSelected(selectedItems, rowData)}
                             onChange={event => {
                                 event.stopPropagation();
                                 onRowClick(rowData);
                             }}
                             style={{ marginLeft: 10 }}
                         />
                     )}</Cell>
                 </Column> */}
                 <Column width={200} fixed sortable resizable>
                     <HeaderCell>Artist Name</HeaderCell>
                    <Cell>{rowData => rowData.name}</Cell>
                 </Column>
                 <Column width={200} fixed sortable resizable>
                     <HeaderCell>First Name</HeaderCell>
                     <Cell>{rowData => rowData.firstName}</Cell>
                 </Column>
                 <Column width={200} fixed sortable resizable>
                     <HeaderCell>Last Name</HeaderCell>
                     <Cell>{rowData => rowData.lastName}</Cell>
                 </Column>
                 <Column width={200} fixed sortable resizable>
                     <HeaderCell>Email Address</HeaderCell>
                     <Cell>{rowData => rowData.email}</Cell>
                 </Column>
                 <Column width={100} fixed sortable resizable>
                     <HeaderCell>Status</HeaderCell>
                     <Cell>{rowData => rowData.status}</Cell>
                 </Column>
                 <Column width={140} fixed sortable resizable>
                    <HeaderCell>Join Date</HeaderCell>
                    <Cell>{rowData => new Date(rowData.joinDate).toLocaleDateString('en-US', {
                        month: '2-digit',
                        day: '2-digit',
                        year: 'numeric'
                        })}
                    </Cell>
                </Column>
                <Column width={140} fixed sortable resizable>
                    <HeaderCell>Updated At</HeaderCell>
                    <Cell>{rowData => new Date(rowData.updatedAt).toLocaleDateString('en-US', {
                        month: '2-digit',
                        day: '2-digit',
                        year: 'numeric'
                        })}
                    </Cell>
                </Column>
                <Column width={140} fixed sortable resizable>
                     <HeaderCell>Lifetime Subscriptions</HeaderCell>
                     <Cell>{rowData => rowData.subscriptions}</Cell>
                 </Column>
                 {/* <Column width={100} fixed sortable resizable>
                     <HeaderCell>Catalog Size</HeaderCell>
                     <Cell>{rowData => rowData.songs?.length || 0}</Cell>
                 </Column> */}
             </Table>
    )
}